import { defineComponent as _defineComponent } from 'vue';
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "siteSearch" };
const _hoisted_2 = { class: "siteSearch-inputField" };
const _hoisted_3 = { class: "siteSearch-adv-control for--dates" };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 1 };
const _hoisted_6 = {
    key: 2,
    class: "siteSearch-adv-dates"
};
const _hoisted_7 = { class: "siteSearch-adv-control for--topics" };
const _hoisted_8 = { class: "siteSearch-adv-end" };
const _hoisted_9 = { class: "siteSearch-adv-search" };
const _hoisted_10 = { class: "topicsModal-inputWrapper" };
const _hoisted_11 = { class: "topicsModal-choicesList" };
const _hoisted_12 = { class: "siteSearch-checkbox" };
const _hoisted_13 = ["checked", "onChange"];
const _hoisted_14 = ["innerHTML"];
import { computed, nextTick, reactive, ref, shallowRef } from 'vue';
import { ThemeButton, ThemeIcon, ThemeModal } from '../../front/components';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ListArticlesFilters',
    props: {
        mod: {}
    },
    setup(__props) {
        var _a, _b, _c, _d;
        const VueDatePicker = shallowRef();
        // Lazy load datepicker, since it's quite heavy
        import('@vuepic/vue-datepicker').then(module => {
            VueDatePicker.value = module.default;
        });
        const props = __props;
        const initialUrl = new URL(location.href);
        const initialArgs = {
            searchQuery: initialUrl.searchParams.get('sok') || '',
            selectedTopicsIds: (initialUrl.searchParams.get(`amne-${props.mod.json.topics.taxonomy}`) || '').split('m').map(v => parseInt(v)).filter(s => s) || [],
            dateFrom: ((_b = (_a = initialUrl.searchParams.get('stdatum')) === null || _a === void 0 ? void 0 : _a.match(/^\d{4}-\d{2}-\d{2}$/)) === null || _b === void 0 ? void 0 : _b[0]) || null,
            dateTo: ((_d = (_c = initialUrl.searchParams.get('sldatum')) === null || _c === void 0 ? void 0 : _c.match(/^\d{4}-\d{2}-\d{2}$/)) === null || _d === void 0 ? void 0 : _d[0]) || null,
            dateMode: initialUrl.searchParams.get('dtyp') || null,
        };
        const args = reactive(Object.assign(Object.assign({}, initialArgs), { topicsSearch: '', selectedTopicsIds: [...initialArgs.selectedTopicsIds] }));
        const topicsData = props.mod.json.topics;
        const topicsModal = ref();
        const topicsModalInput = ref();
        function showTopicSelectionUI() {
            var _a;
            args.topicsSearch = '';
            (_a = topicsModal.value) === null || _a === void 0 ? void 0 : _a.show();
        }
        function applyTopicsSelection() {
            var _a;
            (_a = topicsModal.value) === null || _a === void 0 ? void 0 : _a.dismiss();
        }
        function clearSearchQuery() {
            args.searchQuery = '';
            if (hasChanges.value) {
                commitSearch();
            }
        }
        function onTopicsModalShown() {
            nextTick(() => {
                var _a;
                (_a = topicsModalInput.value) === null || _a === void 0 ? void 0 : _a.focus();
            });
        }
        function onTopicSelectionChange(event, entry) {
            if (event.target.checked) {
                args.selectedTopicsIds.push(entry.id);
            }
            else {
                args.selectedTopicsIds = args.selectedTopicsIds.filter(v => v !== entry.id);
            }
        }
        function prepareModalTopics(values = []) {
            if (args.topicsSearch.length < 2) {
                return values.map(val => (Object.assign(Object.assign({}, val), { visible: true })));
            }
            const words = args.topicsSearch.toLowerCase().split(/[\s._-]/).filter(w => w).slice(0, 10);
            return values.map(val => {
                const visible = words.some(w => val.label.toLowerCase().indexOf(w) >= 0);
                return Object.assign(Object.assign({}, val), { visible });
            });
        }
        const hasChanges = computed(() => {
            return (args.searchQuery !== initialArgs.searchQuery ||
                args.dateFrom !== initialArgs.dateFrom ||
                args.dateTo !== initialArgs.dateTo ||
                args.dateMode !== initialArgs.dateMode ||
                args.selectedTopicsIds.join(',') !== initialArgs.selectedTopicsIds.join(','));
        });
        function commitSearch() {
            const url = new URL(location.href);
            url.pathname = location.pathname.replace(/\/page\/(\d+)/, '');
            for (const pkey of ['dtyp', 'stdatum', 'sldatum', `amne-${props.mod.json.topics.taxonomy}`, 'sok']) {
                if (url.searchParams.has(pkey)) {
                    url.searchParams.delete(pkey);
                }
            }
            if (args.searchQuery) {
                url.searchParams.set('sok', args.searchQuery);
            }
            if (args.dateFrom) {
                url.searchParams.set('stdatum', args.dateFrom);
            }
            if (args.dateTo) {
                url.searchParams.set('sldatum', args.dateTo);
            }
            if (args.dateMode) {
                url.searchParams.set('dtyp', args.dateMode);
            }
            if (args.selectedTopicsIds.length) {
                url.searchParams.set(`amne-${props.mod.json.topics.taxonomy}`, args.selectedTopicsIds.join('m'));
            }
            if (url.toString() !== location.href) {
                window.location.assign(url);
            }
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _withDirectives(_createElementVNode("input", {
                        type: "text",
                        class: "siteSearch-inputField-input",
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((args.searchQuery) = $event)),
                        placeholder: "Sök här...",
                        ref: "ownQueryInputEl",
                        onKeydown: _cache[1] || (_cache[1] = _withKeys(() => (hasChanges.value && commitSearch()), ["enter"]))
                    }, null, 544), [
                        [_vModelText, args.searchQuery]
                    ]),
                    _createVNode(_unref(ThemeIcon), {
                        class: "siteSearch-inputField-icon",
                        name: "magnifying-glass"
                    }),
                    (args.searchQuery)
                        ? (_openBlock(), _createBlock(_unref(ThemeButton), {
                            key: 0,
                            class: "siteSearch-inputField-emptyBtn",
                            "wca-title": "Empty search",
                            icon: "times-round-outline",
                            color: "primary",
                            fill: "none",
                            onClick: clearSearchQuery
                        }))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_3, [
                    (_ctx.mod.json.post_type === 'skp_rnd_thesis')
                        ? (_openBlock(), _createElementBlock("label", _hoisted_4, [
                            _createElementVNode("span", {
                                role: "button",
                                tabindex: "0",
                                class: _normalizeClass({ 'is--active': !args.dateMode }),
                                onClick: _cache[2] || (_cache[2] = ($event) => (args.dateMode = null))
                            }, "Publiceringsdatum", 2),
                            _cache[10] || (_cache[10] = _createElementVNode("span", null, "/", -1)),
                            _createElementVNode("span", {
                                role: "button",
                                tabindex: "0",
                                class: _normalizeClass({ 'is--active': args.dateMode === 'disputationsdatum' }),
                                onClick: _cache[3] || (_cache[3] = ($event) => (args.dateMode = 'disputationsdatum'))
                            }, "Disputationsdatum", 2)
                        ]))
                        : (_openBlock(), _createElementBlock("label", _hoisted_5, "Publiceringsdatum")),
                    (VueDatePicker.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_unref(VueDatePicker), {
                                modelValue: args.dateFrom,
                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event) => ((args.dateFrom) = $event)),
                                placeholder: "Från datum",
                                "model-type": "yyyy-MM-dd",
                                format: "yyyy-MM-dd",
                                "week-numbers": "local",
                                "min-date": "2000-01-01",
                                "max-date": args.dateTo ? new Date(args.dateTo) : new Date(),
                                "enable-time-picker": false,
                                locale: "sv",
                                "cancel-text": "Avbryt",
                                "select-text": "Välj",
                                "now-button-label": "Idag",
                                "week-num-name": "v."
                            }, null, 8, ["modelValue", "max-date"]),
                            _createVNode(_unref(ThemeIcon), { name: "arrow-right-long" }),
                            _createVNode(_unref(VueDatePicker), {
                                modelValue: args.dateTo,
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((args.dateTo) = $event)),
                                placeholder: "Till datum",
                                "model-type": "yyyy-MM-dd",
                                format: "yyyy-MM-dd",
                                "week-numbers": "local",
                                "min-date": args.dateFrom ? new Date(args.dateFrom) : '',
                                "max-date": new Date(),
                                "enable-time-picker": false,
                                locale: "sv",
                                "cancel-text": "Avbryt",
                                "select-text": "Välj",
                                "now-button-label": "Idag",
                                "week-num-name": "v."
                            }, null, 8, ["modelValue", "min-date", "max-date"])
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_7, [
                    _cache[11] || (_cache[11] = _createElementVNode("label", null, "Ämne", -1)),
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", {
                            class: "siteSearch-fauxSelect",
                            onClick: _cache[6] || (_cache[6] = _withModifiers(($event) => (showTopicSelectionUI()), ["prevent"]))
                        }, [
                            _createElementVNode("span", null, _toDisplayString(args.selectedTopicsIds.length
                                ? `${args.selectedTopicsIds.length} ${args.selectedTopicsIds.length === 1
                                    ? 'valt' : 'valda'}` : 'Välj...'), 1),
                            _createVNode(_unref(ThemeIcon), { name: "chevron-down" })
                        ]),
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_unref(ThemeButton), {
                                title: "Sök",
                                color: "primary",
                                onClick: _cache[7] || (_cache[7] = ($event) => (commitSearch())),
                                disabled: !hasChanges.value
                            }, null, 8, ["disabled"])
                        ])
                    ])
                ]),
                _createVNode(_unref(ThemeModal), {
                    ref_key: "topicsModal",
                    ref: topicsModal,
                    classes: "topicsModal",
                    title: `Välj ${_unref(topicsData).label}`,
                    actions: [
                        { title: 'Avbryt', handler: 'dismiss', color: 'neutral', iconAfter: 'times' },
                        {
                            title: (args === null || args === void 0 ? void 0 : args.selectedTopicsIds.length) ? `Välj ${args.selectedTopicsIds.length}st` : 'Välj',
                            handler: () => applyTopicsSelection(),
                            iconAfter: 'check',
                            fill: 'solid'
                        },
                    ],
                    onShown: onTopicsModalShown
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_10, [
                            _withDirectives(_createElementVNode("input", {
                                type: "text",
                                ref_key: "topicsModalInput",
                                ref: topicsModalInput,
                                class: _normalizeClass({ 'is--active': args.topicsSearch }),
                                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event) => ((args.topicsSearch) = $event))
                            }, null, 2), [
                                [_vModelText, args.topicsSearch]
                            ]),
                            _createVNode(_unref(ThemeIcon), { name: "magnifying-glass" })
                        ]),
                        _createElementVNode("div", _hoisted_11, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(prepareModalTopics(_unref(topicsData).list), (entry) => {
                                return _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_12, [
                                    _createElementVNode("input", {
                                        type: "checkbox",
                                        checked: args.selectedTopicsIds.findIndex(v => v === entry.id) >= 0,
                                        onChange: ($event) => (onTopicSelectionChange($event, entry))
                                    }, null, 40, _hoisted_13),
                                    _createVNode(_unref(ThemeIcon), { name: "check" }),
                                    _createElementVNode("span", {
                                        innerHTML: entry.label
                                    }, null, 8, _hoisted_14)
                                ], 512)), [
                                    [_vShow, entry.visible]
                                ]);
                            }), 256))
                        ]),
                        _createVNode(_unref(ThemeButton), {
                            class: "topicsModal-uncheckBtn",
                            title: "Avmarkera alla",
                            color: "light",
                            size: "small",
                            disabled: !args.selectedTopicsIds.length,
                            onClick: _cache[9] || (_cache[9] = ($event) => (args.selectedTopicsIds = []))
                        }, null, 8, ["disabled"])
                    ]),
                    _: 1
                }, 8, ["title", "actions"])
            ]));
        };
    }
});
